// extracted by mini-css-extract-plugin
export default {"reset-password-form":"ResetPasswordForm_reset-password-form__IpIiq","back-btn":"ResetPasswordForm_back-btn__w-RlL"};